import './LoadingAlert.less';
import React from 'react';
import __ from "../../i18n";
import Spinner from "../../../bootstrap/components/spinner/Spinner";
import LayoutPortal from "../../../bootstrap/components/layout-portal/LayoutPortal";


export default function LoadingAlert() {

    return <LayoutPortal>
        <div className="loading-alert">
            <Spinner size={1.5}/>
            <div className="text">{__('Loading...')}</div>
        </div>
    </LayoutPortal>;
}
